export default "__VITE_ASSET__B4ukNS95__"